import { useWindowSize } from '@/hooks/useWindowSize';
import { AffiliateStepsDesktop } from './desktop';
import { AffiliateStepsMobile } from './mobile';

const AffiliateSteps = props => {
  const { innerWidth } = useWindowSize();

  return innerWidth <= 900 ? (
    <AffiliateStepsMobile {...props} />
  ) : (
    <AffiliateStepsDesktop {...props} />
  );
};

export default AffiliateSteps;
